import { Injectable } from '@angular/core';

@Injectable()
export class TableKeyBindService {
    private keyBindItems: any[];
    private currentItemIndex: number;

    public addItems(items: NodeList) {
        this.keyBindItems = Array.from(items);
    }

    public clearItems() {
        this.currentItemIndex = undefined;
        this.keyBindItems = [];
    }

    public setCurrentElement(element: Element): void {
        if (this.keyBindItems && this.keyBindItems.length > 0) {
            this.currentItemIndex = this.keyBindItems.findIndex(item => item === element);
        }
    }

    public clickCurrentElement(): void {
        const element = this.keyBindItems[this.currentItemIndex];
        if (element) {
            element.click();
        }
    }

    public focusElement(prev?: boolean): void {
        if (!this.keyBindItems || this.keyBindItems.length === 0) {
            return;
        }

        if (this.currentItemIndex === undefined) {
            this.currentItemIndex = 0;
        } else if (prev) {
            this.currentItemIndex =
                this.currentItemIndex > 0 ? this.currentItemIndex - 1 : this.keyBindItems.length - 1;
        } else {
            this.currentItemIndex =
                this.currentItemIndex < this.keyBindItems.length - 1 ? this.currentItemIndex + 1 : 0;
        }

        const nextItem = this.keyBindItems[this.currentItemIndex];
        nextItem.focus();
        nextItem.click();
    }
}
